/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RemoteSession, RemoteSession$inboundSchema } from "./remotesession.js";

export type PrincipalRemoteSessionBinding = {
  id: string;
  principalId: string;
  /**
   * A remote_session record — Speakeasy's upstream OAuth session for a (principal, remote_session_client) pair. access_token_encrypted and refresh_token_encrypted are never returned.
   */
  remoteSession?: RemoteSession | undefined;
  remoteSessionClientId: string;
  remoteSessionId: string;
  userSessionIssuerId: string;
};

/** @internal */
export const PrincipalRemoteSessionBinding$inboundSchema: z.ZodMiniType<
  PrincipalRemoteSessionBinding,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    principal_id: z.string(),
    remote_session: z.optional(RemoteSession$inboundSchema),
    remote_session_client_id: z.string(),
    remote_session_id: z.string(),
    user_session_issuer_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "principal_id": "principalId",
      "remote_session": "remoteSession",
      "remote_session_client_id": "remoteSessionClientId",
      "remote_session_id": "remoteSessionId",
      "user_session_issuer_id": "userSessionIssuerId",
    });
  }),
);

export function principalRemoteSessionBindingFromJSON(
  jsonString: string,
): SafeParseResult<PrincipalRemoteSessionBinding, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PrincipalRemoteSessionBinding$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PrincipalRemoteSessionBinding' from JSON`,
  );
}
